export const WARNING_1 = 'warning-1';
export const WARNING_2 = 'warning-2';
export type WarningType = typeof WARNING_1 | typeof WARNING_2;
